import React from 'react';

const CARRIER_STYLES: Record<string, { bg: string; fg: string }> = {
  'BRT': { bg: '#8B0000', fg: '#FFFFFF' },
  'TNT': { bg: '#FF6600', fg: '#FFFFFF' },
  'GLS': { bg: '#FFD700', fg: '#003399' },
  'SDA': { bg: '#003893', fg: '#FFFFFF' },
  'DHL': { bg: '#FFCC00', fg: '#CC0000' },
  'UPS': { bg: '#351C15', fg: '#FFB500' },
};

interface CarrierLogoProps {
  code: string;
  size?: 'sm' | 'md';
}

export function CarrierLogo({ code, size = 'md' }: CarrierLogoProps) {
  const style = CARRIER_STYLES[code] || { bg: '#6B7280', fg: '#FFFFFF' };
  const dims = size === 'sm' ? 'w-8 h-5' : 'w-10 h-6';
  const fontSize = size === 'sm' ? 'text-[8px]' : 'text-[10px]';

  return (
    <div className={`${dims} rounded flex items-center justify-center flex-shrink-0 ${fontSize} font-black tracking-wider`}
      style={{ backgroundColor: style.bg, color: style.fg }}>
      {code}
    </div>
  );
}
